import type { MemorySliceDescriptor } from "../../shared";
import { referenceEqual, useMemorySliceSelector } from "../../shared";
import { ephemeralStore } from "../runtime/ephemeralStore";

/**
 * Subscribes to a derived portion of an ephemeral slice to limit re-renders.
 *
 * @typeParam TValue Full slice value type.
 * @typeParam TSelected Projected value type.
 * @param slice Slice descriptor.
 * @param selector Projection from full slice value; should be stable (`useCallback`) when non-trivial.
 * @param isEqual Equality for selected values (defaults to `Object.is`).
 * @returns Selected value; re-renders only when the selection changes per `isEqual`.
 */
export const useEphemeralSelector = <TValue, TSelected>(
    slice: MemorySliceDescriptor<TValue>,
    selector: ( value: TValue ) => TSelected,
    isEqual: ( left: TSelected, right: TSelected ) => boolean = referenceEqual,
): TSelected => {
    return useMemorySliceSelector( ephemeralStore, slice, selector, isEqual );
};
